import { logout } from '../authSlice';

const errorMiddleware = (store) => (next) => (action) => {
  if (action.type.endsWith('/rejected')) {
    const errorMessage = action.payload?.error || action.payload?.message || 'Ha ocurrido un error inesperado.';
    const status = action.payload?.status || 500;

    // Caso específico: sesión expirada o inválida (403)
    if (
      status === 403 && 
      (errorMessage.includes('La sesión ha expirado') || 
      (errorMessage.includes('sesión inválida'))
    )) {
      // Despachar logout para limpiar el estado de Redux y localStorage
      store.dispatch(logout());
      
      // Redirigir al login (usando window.location para asegurar recarga completa)
      window.location.href = '/login';
      return; // Detener el flujo aquí
    }

    // Otros errores: mostrarlos en el GlobalError
    store.dispatch({
      type: 'error/setError',
      payload: { message: errorMessage, status },
    });
  }
  return next(action);
};

export default errorMiddleware;